import { Box, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { concat, get } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { APIS } from '../../../../../../lib/constants/apis';
import { FormStrucItem } from '../../../../../../lib/types/types';
import { BICValidation, IBANValidation, Required } from '../../../../../../lib/validation/ValidationTypes';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../lib/paths/mittelabruf_FULL_Paths.json';
const P = Schema.attributes;

const BankDaten: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title='Überprüfung Ihrer Daten' description='Bitte überprüfen Sie die von Ihnen bereits gemachten Angaben.' />

			<Box sx={{ mt: '2rem' }}>
				<Grid2 container spacing={6}>
					<Grid2 sm={6}>
						<Typography variant='h6'>Organisation</Typography>
						<CreateForm
							formValues={application}
							formStruc={OrgaDetails()}
							updateFormValuesFunc={setApplicationProperty}
							readOnly={readOnly}
							api={APIS.Antrag}
						/>
					</Grid2>
					<Grid2 sm={6}>
						<Typography variant='h6'>Bankdaten</Typography>
						<CreateForm
							formValues={application}
							formStruc={formStrucBankDaten(application)}
							updateFormValuesFunc={setApplicationProperty}
							readOnly={readOnly}
						/>
					</Grid2>
				</Grid2>
			</Box>
		</>
	);
};
export default BankDaten;

export const formStrucBankDaten = (application: any) => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Bankverbindung_Kontoinhaber,
				{ ...P.Bankverbindung_IBAN, validation: [{ validateFunction: Required }, { validateFunction: IBANValidation }] },
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{
			fields: [{ ...P.Bankverbindung_BIC, validation: [{ validateFunction: Required }, { validateFunction: BICValidation }] }],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];

	const iban = get(application, P.Bankverbindung_IBAN.path, '');
	if (typeof iban === 'string' && iban.includes('DE')) {
		struc.pop();
	}

	return struc;
};
export const OrgaDetails = () => {
	return [
		{
			fields: [
				{
					...P.Foerderantrag.schema.attributes.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation,
					disabled: true,
				},
				{
					...P.Foerderantrag.schema.attributes.Antragstellende_Organisation_Rechtsform_Der_Organisation,
					disabled: true,
				},
				{
					...P.Foerderantrag.schema.attributes.Antragstellende_Organisation_Strasse_Und_Hausnummer,
					disabled: true,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{
			fields: [
				{
					...P.Foerderantrag.schema.attributes.Antragstellende_Organisation_PLZ,
					disabled: true,
				},
				{
					...P.Foerderantrag.schema.attributes.Antragstellende_Organisation_Ort,
					disabled: true,
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
};
export const getFormStrucBankDaten = (application: any) => {
	return concat(formStrucBankDaten(application), OrgaDetails());
};
